<template>
  <div>
    <!-- 订单翻译 -->
    <baseBreadcrumb :page="$t('message.ordersForTranslation')" :menu="$t('message.orderForm')" />
    <orderMain status="20" />
    <!-- <iframe src="http://127.0.0.1:5173/?customer=jushuitan&bizType=ERP" frameborder="0" id="myIframe"
      style="width:100%"></iframe> -->
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped></style>